import { useOutletContext } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';
import type { AppShellContext } from '@/components/layout/AppShell';
import { HrTabs } from '@/components/hr/HrTabs';
import { ReimbursementsView } from '@/components/hr/ReimbursementsView';
import { useHrMe } from '@/components/hr/useHrData';

/** Employee expense reimbursements: request wizard + own requests + approval queue. */
export function HrReimbursementsPage() {
  const { nip } = useOutletContext<AppShellContext>();
  const { hrMe, loading } = useHrMe(nip);

  if (loading) {
    return (
      <div className="flex flex-col gap-4">
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-72 w-full" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <HrTabs nip={nip} hrMe={hrMe} />
      <ReimbursementsView nip={nip} hrMe={hrMe} />
    </div>
  );
}
